// extracted by mini-css-extract-plugin
module.exports = {"page":"_-_-pharmacy-src-display-page-page__page--2nKri"};